import React, { createContext, useState, useContext, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    try { return localStorage.getItem('language') === 'zh' ? 'zh' : 'en'; }
    catch { return 'en'; }
  });

  const [showTooltip, setShowTooltip] = useState(() => {
    // Check if user has dismissed the tooltip
    try { return localStorage.getItem('languageTooltipDismissed') !== 'true'; }
    catch { return true; }
  });

  useEffect(() => {
    document.documentElement.lang = language === 'zh' ? 'zh-CN' : 'en';
    try { localStorage.setItem('language', language); } catch { /* Language still works if storage is unavailable. */ }
  }, [language]);

  const changeLanguage = (lang) => {
    if (lang === 'en' || lang === 'zh') setLanguage(lang);
  };

  const dismissTooltip = () => {
    setShowTooltip(false);
    try { localStorage.setItem('languageTooltipDismissed', 'true'); } catch { /* Optional preference. */ }
  };

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, showTooltip, dismissTooltip }}>
      {children}
    </LanguageContext.Provider>
  );
};
